import React from 'react';
import { Link } from 'react-router-dom';
import { shapes } from '../data/mock';

export default function ShopByShape() {
  return (
    <section className="py-14 sm:py-16 bg-[#f6f2ea]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-neutral-900 inline-flex items-center gap-3 flex-wrap justify-center">
            <span className="italic">SHOP BY</span>
            <span className="font-semibold">SHAPE</span>
          </h2>
          <svg className="mx-auto mt-2" width="140" height="12" viewBox="0 0 140 12" fill="none">
            <path d="M2 8 Q35 -2 70 6 T138 5" stroke="#1e3a2b" strokeWidth="2" strokeLinecap="round" fill="none" />
          </svg>
        </div>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
          {shapes.map(s => (
            <Link
              key={s.id}
              to="/collection/all"
              className="group relative block overflow-hidden rounded-xl shadow-sm hover:shadow-xl transition-all"
            >
              <div className="aspect-square bg-neutral-100 overflow-hidden">
                <img src={s.image} alt={s.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent flex items-end p-4">
                <span className="text-white font-serif text-2xl">{s.name}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
